export default function CompanyPageEventModel() {
    return {
        supplierId: window?.companyId,
        supplierName: window?.companyName,
        supplierSlug: window?.companySlug,
    }
}